import {
  AxisValue,
  VariantsAxis,
  Product,
  VariantsModel,
  VariantsEntity,
  VariantAxisPoint,
  VariantsAxisModel,
} from '../types';

const AXIS_AS_IMAGE_THUMB_CRITERIA = 'цвет';

export const processFetchedResult =
  (productId: string) =>
  (data: VariantsEntity | null): VariantsModel => {
    let variantsModel: VariantsAxisModel[] = [];
    let activePoint: Product | undefined;

    if (data) {
      const { products = [], axisList = [] } = data;
      activePoint = products.find((p) => p.productId === productId);
      if (activePoint) {
        variantsModel = getVariantsModel(activePoint, axisList, products);
      }
    }

    return {
      variantsModel,
      activePoint,
    };
  };

const getAxisValue = (axisId: string, axisValues: AxisValue[]): string =>
  axisValues.find((av: AxisValue) => av.id === axisId)?.axis || '';

const getVariantsModel = (
  activePoint: Product,
  axisList: VariantsAxis[],
  products: Product[],
): VariantsAxisModel[] =>
  axisList.map((axisMeta) => {
    const pointsOnAxis = getProductsOnAxis(activePoint, products, axisMeta, axisList);
    const asImageThumb = axisMeta.name.toLowerCase() === AXIS_AS_IMAGE_THUMB_CRITERIA;
    return {
      axisMeta,
      pointsOnAxis,
      asImageThumb,
    };
  });

const getProductsOnAxis = (
  activePoint: Product,
  products: Product[],
  axisMeta: VariantsAxis,
  axisList: VariantsAxis[],
) => {
  const { attribute: currentAxisId } = axisMeta;
  const otherAxes = axisList.filter(({ attribute }) => attribute !== currentAxisId);

  const productsByAxisValue = products
    .filter(({ axesValues }) => axesValues.some(({ id }) => id === currentAxisId))
    .reduce((result, product) => {
      const { axesValues, productId } = product;
      const currentAxisValue = getAxisValue(currentAxisId, axesValues);
      const areOtherAxesValueMatched =
        axisList.length > 1
          ? otherAxes.every(
              ({ attribute }) =>
                getAxisValue(attribute, axesValues) === getAxisValue(attribute, activePoint.axesValues),
            )
          : true;

      if (
        !result.has(currentAxisValue) ||
        ((activePoint.productId === productId || areOtherAxesValueMatched) && result.has(currentAxisValue))
      ) {
        result.set(currentAxisValue, {
          isPuncturedPoint: !areOtherAxesValueMatched,
          label: currentAxisValue,
          axis: axisMeta.name,
          toProductUrl: product.productLink,
          mainPhoto: product.mediaMainPhoto,
          displayedName: product.displayedName,
          productPrice: product.productPrice,
          productId: product.productId,
          productBelong: product.productBelong,
        });
      }

      return result;
    }, new Map<string, VariantAxisPoint>());

  return Array.from(productsByAxisValue.values());
};
